export enum RouteEnum {
  WELCOME = '/',
  // AUTH = '/authentication',
  // LOGIN_OTP = '/login-otp',
  HOME = '/home',
  LOGIN_USERNAME = '/login-username',
  LOGIN_PASSWORD = '/login-password',
  LOGOUT = '/logout',
  
  // password
  CREATE_PASSWORD = '/create-password',
  FORGOT_PASSWORD_OTP_REQUEST = '/request/otp/forgot-password',
  RESET_PASSWORD = '/reset-password',
  VALIDATE_OTP_RESET_PASSWORD = '/validation/otp/reset-password',
  
  // Signup & Personal Info
  CREATE_PASSWORD_ONBOARDING = '/onboarding/password/register',
  PERSONAL = '/personal',
  CONTACT = '/contact',
  ADDRESS = '/address',
  
  // Validation
  OTP_REQUEST = '/request/otp',
  OTP_VALIDATION = '/validation/otp',
  SIGNUP_VALIDATION = '/validation/signup',
  SIGNUP_VALIDATION_CODE = '/code/signup',
  PASSWORD_VALIDATION = '/validation/password',
  PASSWORD_VALIDATION_CODE = '/code/password',
  
  // Miscellaneous
  INVITATION = '/invitation',
  ADD_INFO = '/info',
  FINISH = '/finish',
  OTP = '/otp',
  COMPLEMENTARY_STEP = '/complementary-step',
}
